import _values from 'lodash/fp/values';

const defaultInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'Id'
		},
		title: {
			index: 'title',
			title: 'Title'
		},
		leads_required: {
			index: 'leads_required',
			title: 'Leads required'
		},
		offer_category: {
			index: 'offer_category',
			title: 'Offer category'
		},
		actions: {
			title: 'Actions'
		}
	}
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {
	const initialState = {
		...defaultInitialState
	};

	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data;
			const mappedRows = rows && rows.map(row => ({ ...row }));

			return {
				headers: _values(table.columns),
				rows: mappedRows
			};
		}
	};

	return {
		initialState,
		selectors
	};
};

export default createTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/achievement/components/table/index.js